<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>对账单</h1>
        <p>月度结算单查看与确认。分账基数只含自充积分消耗。15 日前确认，逾期视为认可。确认后总部复核，再去提现页上传发票。</p>
      </div>
      <div class="ch-actions">
        <button class="ch-btn" type="button" @click="$router.push('/partner/lines')">查看分账明细</button>
      </div>
    </div>
    <div v-if="pending" class="ch-banner">
      <div>
        <b>{{ pending.periodMonth }} 月度结算单待确认</b>
        <p>应结 ¥ {{ yuan(pending.amount) }} · 请于 {{ pending.confirmDeadline || '当月 15 日' }} 前确认</p>
      </div>
      <div class="ch-actions">
        <button class="ch-btn" type="button" @click="act(pending, 'dispute')">提交异议</button>
        <button class="ch-btn gold" type="button" @click="act(pending, 'confirm')">确认结算单</button>
      </div>
    </div>
    <div class="ch-panel">
      <h2>结算单列表</h2>
      <table class="ch-table">
        <thead><tr><th>结算周期</th><th>返佣金额</th><th>状态</th><th>确认截止</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>{{ row.periodMonth }}</td>
            <td>¥ {{ yuan(row.amount) }}</td>
            <td><span class="ch-tag" :class="tagOf(row.status)">{{ statusName(row.status) }}</span></td>
            <td>{{ row.confirmDeadline || '—' }}</td>
            <td>
              <button v-if="row.status === 'PENDING_CONFIRM'" class="ch-link" type="button" @click="act(row, 'confirm')">确认</button>
              <button v-if="row.status === 'PENDING_CONFIRM'" class="ch-link" type="button" @click="act(row, 'dispute')">异议</button>
              <span v-if="row.status !== 'PENDING_CONFIRM'">—</span>
            </td>
          </tr>
          <tr v-if="!list.length"><td colspan="5" class="ch-empty">还没有结算单</td></tr>
        </tbody>
      </table>
    </div>
    <div v-if="current" class="ch-panel">
      <h2>{{ current.periodMonth }} 结算单构成</h2>
      <div class="ch-kv">
        <span>每级返佣</span><b>¥ {{ yuan(current.amount) }}</b>
        <span>应结金额</span><b>¥ {{ yuan(current.amount) }}</b>
      </div>
      <p class="ch-note" style="margin-top:12px">当前结算单只汇总每级返佣。折扣结算、续费返佣、项目奖、达标奖和退款红冲还没有并进这张单。</p>
    </div>
  </div>
</template>

<script>
import { getChannelSettlements, advanceChannelSettlement } from '@/api/admin'
import { statusName, yuan } from './labels'

export default {
  name: 'PartnerStatements',
  data() { return { list: [] } },
  computed: {
    pending() { return this.list.find(item => item.status === 'PENDING_CONFIRM') },
    current() { return this.pending || this.list[0] }
  },
  created() { this.load() },
  methods: {
    statusName, yuan,
    tagOf(status) {
      if (status === 'PAID' || status === 'DONE' || status === 'CONFIRMED') return 'ok'
      if (status === 'DISPUTED') return 'bad'
      return 'warn'
    },
    async load() {
      const result = await getChannelSettlements()
      this.list = result.list || []
    },
    async act(row, action) {
      await advanceChannelSettlement(row.id, { action })
      this.$message.success(action === 'confirm' ? '已确认' : '已提交异议')
      this.load()
    }
  }
}
</script>
